import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  const title = (props && props.title) || ''
  return (
    <Svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#EAF1FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5269 11.4286C13.5269 7.87817 16.4051 5 19.9555 5C23.5059 5 26.3841 7.87817 26.3841 11.4286C26.3841 14.979 23.5059 17.8571 19.9555 17.8571C16.4051 17.8571 13.5269 14.979 13.5269 11.4286Z"
        fill="#286EFA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.17155 31.579C8.28203 25.1651 13.5155 20 19.9555 20C26.3957 20 31.6292 25.1653 31.7394 31.5795C31.7467 32.0049 31.5017 32.3943 31.115 32.5717C27.7165 34.1311 23.9362 35 19.9559 35C15.9753 35 12.1947 34.131 8.79594 32.5713C8.40927 32.3938 8.16422 32.0044 8.17155 31.579Z"
        fill="#286EFA"
      />
    </Svg>
  )
}
